"use strict";

var _interopRequireDefault = require("D:/nodeApp/hj-aadmin-vue-new/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/nodeApp/hj-aadmin-vue-new/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/nodeApp/hj-aadmin-vue-new/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/nodeApp/hj-aadmin-vue-new/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _getPageTitle = _interopRequireDefault(require("@/libs/getPageTitle"));
var _auth = require("./libs/auth");
var _routers = require("./router/routers");
// progress bar
// progress bar style

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/admin/login']; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var hasToken, permissions, accessRoutes;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          _nprogress.default.start();
          // set page title
          document.title = (0, _getPageTitle.default)(to.meta.title);
          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.next = 34;
            break;
          }
          if (!(to.path === '/admin/login')) {
            _context.next = 9;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          _nprogress.default.done();
          _context.next = 32;
          break;
        case 9:
          // 获取permission,用户信息在登录时候已经存永久
          permissions = _store.default.getters.permissions && _store.default.getters.permissions.length > 0;
          if (!permissions) {
            _context.next = 14;
            break;
          }
          next();
          _context.next = 32;
          break;
        case 14:
          _context.prev = 14;
          _context.next = 17;
          return _store.default.dispatch('user/setUserInfo');
        case 17:
          _context.next = 19;
          return _store.default.dispatch('permission/loadPermissions');
        case 19:
          // TODO: 前端路由可以由后端生成,现在直接写死的,菜单不是由路由生成
          // 可以参考: https://segmentfault.com/a/1190000015419713
          // 现在这样也行吧
          accessRoutes = _store.default.getters.menus; // 只会有两层
          // dynamically add accessible routes
          accessRoutes.forEach(function (item) {
            // 如果一级菜单没有子菜单,那么加到mian上
            if (item.parent_id === 0 && !item.children) {
              _router.default.addRoute('main', item);
            } else {
              _router.default.addRoute(item);
            }
          });
          _router.default.addRoute(_routers.errorRoute);
          // 报错vue-router Uncaught (in promise) undefined https://github.com/vuejs/vue-router/issues/2873
          // 这里也是一个坑，不能使用简单的 next()
          // 如果直接使用 next() 刷新后会一直白屏
          next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
            replace: true
          }));
          // next()
          _context.next = 32;
          break;
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](14);
          _context.next = 29;
          return _store.default.dispatch('user/resetToken');
        case 29:
          _elementUi.Message.error(_context.t0.message || 'Has Error');
          next("/admin/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 32:
          _context.next = 35;
          break;
        case 34:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/admin/login?redirect=".concat(to.path));
            _nprogress.default.done();
          }
        case 35:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 25]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});